// ===================== VIDEO PLAYER =====================

document.querySelectorAll('.video-card').forEach(card => {
    const video = card.querySelector('.video-el, video');
    const playBtn = card.querySelector('.play-btn');

    if (!video || !playBtn) return;

    // ===== State =====
    const isPlaying = () => card.dataset.playing === 'true';

    const setPlaying = (playing) => {
        card.dataset.playing = playing ? 'true' : 'false';
        card.classList.toggle('playing', playing);

        // CRITICAL FIX: Button hamesha click-able rahe!
        // Sirf opacity change karo, pointer-events NEVER disable karo
        playBtn.style.opacity = playing ? '0' : '1';
        // pointer-events: auto RAKHO - bas icon change karo
        playBtn.style.pointerEvents = 'auto';
    };

    // ===== Pause all other videos =====
    const pauseOthers = () => {
        document.querySelectorAll('.video-card').forEach(other => {
            if (other === card) return;

            other.dataset.playing = 'false';
            other.classList.remove('playing');

            const otherBtn = other.querySelector('.play-btn');
            if (otherBtn) {
                otherBtn.style.opacity = '1';
                otherBtn.style.pointerEvents = 'auto';
            }

            const otherVideo = other.querySelector('.video-el, video');
            if (otherVideo) {
                otherVideo.pause();
                otherVideo.currentTime = 0;
                otherVideo.muted = true;
            }
        });
    };

    // ===== DESKTOP: Hover preview =====
    card.addEventListener('mouseenter', () => {
        if (!isPlaying() && !window.matchMedia('(pointer: coarse)').matches) {
            video.muted = true;
            video.play().catch(() => {});
        }
    });

    card.addEventListener('mouseleave', () => {
        if (!isPlaying() && !window.matchMedia('(pointer: coarse)').matches) {
            video.pause();
            video.currentTime = 0;
        }
    });

    // ===== PLAY BUTTON: Click / Touch to Toggle Play/Pause =====
    // SAME button se play bhi hoga, pause bhi hoga
    const togglePlay = (e) => {
        e.stopPropagation();
        e.preventDefault();

        pauseOthers();

        if (!isPlaying()) {
            // PLAY
            video.muted = false;
            video.play()
                .then(() => setPlaying(true))
                .catch(() => {
                    setPlaying(false);
                });
        } else {
            // PAUSE
            video.pause();
            video.currentTime = 0;
            video.muted = true;
            setPlaying(false);
        }
    };

    playBtn.addEventListener('click', togglePlay);
    playBtn.addEventListener('touchend', (e) => {
        e.preventDefault();     // mouse click emulate roke
        e.stopPropagation();
        togglePlay(e);
    });

    // ===== Video ended → reset =====
    video.addEventListener('ended', () => {
        setPlaying(false);
        video.currentTime = 0;
    });

    // ===== Video error → reset =====
    video.addEventListener('error', () => {
        setPlaying(false);
    });

    // ===== MOBILE PRELOAD FIX =====
    // Desktop pe hover se video load hoti hai, mobile pe nahi.
    // Is liye jab card viewport mein aaye, video ka first frame load karo.

    // Method 1: preload="auto" se bhi mobile pe first frame nahi aata
    // Method 2: IntersectionObserver se force load karo

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Video viewport mein aa gayi → first frame load karo
                    if (video.readyState < 2) { // HAVE_CURRENT_DATA nahi hai
                        video.load(); // Force reload taake first frame aa jaye
                    }
                }
            });
        }, { threshold: 0.1 });

        observer.observe(card);
    } else {
        // Fallback: directly load
        video.load();
    }
});
